'use client';
import { atom, useAtom, useSetAtom, WritableAtom } from 'jotai';
import { IFanConversationSet } from '@ui/components';

export type GroupSettingsPayload = {
  conversationData: IFanConversationSet;
};

export const groupSettingsDataAtom = atom<GroupSettingsPayload | null>(null) as WritableAtom<
  GroupSettingsPayload | null,
  [GroupSettingsPayload | null],
  void
>;
export const groupSettingsOpenAtom = atom<boolean>(false) as WritableAtom<boolean, [boolean], void>;

export const triggerGroupSettingsAtom = atom(null, (get, set, payload: GroupSettingsPayload) => {
  set(groupSettingsDataAtom, payload);
  set(groupSettingsOpenAtom, true);
});

export const flushGroupSettingsAtom = atom(null, (get, set) => {
  set(groupSettingsDataAtom, null);
  set(groupSettingsOpenAtom, false);
});

export function useGroupSettingsState() {
  const [groupSettingsData] = useAtom(groupSettingsDataAtom);
  const [isOpen] = useAtom(groupSettingsOpenAtom);
  const triggerGroupSettings = useSetAtom(triggerGroupSettingsAtom);
  const flushGroupSettings = useSetAtom(flushGroupSettingsAtom);

  return {
    groupSettingsData,
    isOpen,
    onOpenGroupSettings: (payload: GroupSettingsPayload) => triggerGroupSettings(payload),
    onCloseGroupSettings: () => flushGroupSettings(),
  };
}
